/**
 * @desc 查询月计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthInfoResponse>> {
  return defHttp.post({
    url: '/web/plan/month/queryPlanInfo',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthInfoResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/month/queryPlanInfo',
    data,
  });
}
